var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo } from 'react';
import { ECollectionBannerState } from '../types';
import { useCardsCollections } from '../collectionsList';
import useNextInvalidationTimestamp from '../../../hooks/useNextInvalidationTimestamp';
var getBannerAvailabilityState = function (collectionData) {
    if (Date.now() < Date.parse(collectionData.availableFrom)) {
        return ECollectionBannerState.UPCOMING;
    }
    if (Date.now() > Date.parse(collectionData.availableUntil)) {
        return ECollectionBannerState.EXPIRED;
    }
    return ECollectionBannerState.AVAILABLE;
};
var getStateChangeDate = function (collectionData) {
    if (Date.now() < Date.parse(collectionData.availableFrom)) {
        return collectionData.availableFrom;
    }
    if (Date.now() < Date.parse(collectionData.availableUntil)) {
        return collectionData.availableUntil;
    }
    return collectionData.showUntil;
};
var useBannersAvailabilityState = function () {
    var activeCollections = useCardsCollections().items;
    var getNextInvalidationTimestamp = useCallback(function () {
        var nextUpdateTimestamps = activeCollections
            .filter(function (collection) { return Date.now() < Date.parse(collection.showUntil); })
            .map(function (activeCollection) { return Date.parse(getStateChangeDate(activeCollection)); });
        return nextUpdateTimestamps.length ? Math.min.apply(Math, nextUpdateTimestamps) + 1500 : null;
    }, [activeCollections]);
    var nextInvalidationTimestamp = useNextInvalidationTimestamp(getNextInvalidationTimestamp);
    return useMemo(function () { return activeCollections
        .filter(function (activeCollection) { return Date.now() < Date.parse(activeCollection.showUntil); })
        .map(function (activeCollection) { return (__assign(__assign({}, activeCollection), { state: getBannerAvailabilityState(activeCollection) })); }); }
    // eslint-disable-next-line
    , [nextInvalidationTimestamp, activeCollections]);
};
export default useBannersAvailabilityState;
